import { connect, MapStateToProps } from 'react-redux'
import carlineFilterOptionsSelector from '../../redux/selectors/carlines/carlineFilterOptionsSelector'
import { applyFilter, removeEntireFilter, resetFiltersState } from '../../redux/actions/app/filter.actions'
import { Props } from '../attribute-filters'
import filtersSelector from '../../redux/selectors/filtersSelector'
import isTranslationDebugEnabledSelector
    from '../../redux/selectors/isTranslationDebugEnabledSelector'

type StateProps = Pick<Props, 'filterOptions' | 'selectedFilters' | 'translationDebugEnabled'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    filterOptions: carlineFilterOptionsSelector(state),
    selectedFilters: filtersSelector(state),
    translationDebugEnabled: isTranslationDebugEnabledSelector(state),
})

type DispatchProps = Pick<Props, 'applyFilter' | 'removeFilter' | 'resetFilters'>

const mapDispatchToProps: DispatchProps = {
    applyFilter,
    removeFilter: removeEntireFilter,
    resetFilters: resetFiltersState,
}

export default connect(mapStateToProps, mapDispatchToProps)
